import { actionTypes } from "../actions/campaigns";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGNS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;